

















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import ProfitChangeDialog from '@/modules/profit/components/admin/ProfitChangeDialog.vue'
import UserService from '@/modules/user/services/user.service'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'

@Component({
  components: { ProfitChangeDialog }
})
export default class ProfitValue extends Vue {
  @Prop() useCase!: BaseRequestLoadingHandler
  @Prop() id!: number[] | number
  @Prop({ default: 0 }) amount !: number
  @Prop({ default: true }) editable !: boolean
  @Prop({ default: false }) hasPermission !: boolean

  constructor(
    private readonly userService: UserService
  ) {
    super()
  }

  private get getAmount() {
    return Number(this.amount).toLocaleString()
  }

  private get checkPermission() {
    return ((this.hasPermission && this.userService.can('see-profit')) || !this.hasPermission)//todo: it doesn't work
  }
}
